import React, { useState, useMemo } from 'react';
import { IReferens } from '../../Queries/VerifikationQuery/VerifikationQuery';
import EDSortableTable from '../../../../../../../../../BaseComponents/Table/Components/EDSortableTable';
import { numberOrStringCompare } from '../../../../../../../../../BaseComponents/Table/Components/SortableTableUtils';
import { IColumnDef } from '../../../../../../../../../Types/ColumnDefType';
import { findCollectionStatic } from '../../../../../../../../../Model/avenyStaticModelUtils';
import BusinessDataSet from '../../../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataSet/BusinessDataSet';
import { EDFullscreenPaper } from '../../../../../../../../../BaseComponents/FullscreenModal/Components/EDFullscreenPaper';
import ObjektVySida from '../../../../../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import { VisningsTypContext } from '../../../../../../../_Common/Components/BusinessCollectionComponents/VisningsTypContext/VisningsTypContext';
import { rutinInfos } from '../../../../../../../_Common/Const/RutinInfo';
import AttributGrupp from '../../../../../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import VerifikationDialog from '../../VerifikationDialog';
import { selectedId } from '../../../../../../../../../Components/MasterDetail/MasterDetailUtils';
import { TSelectedDetail } from '../../../../../../../../../Types/MasterDetailTypes';

interface IProps {
  referenser: IReferens[];
  canViewVerifikationRader: boolean;
  referenceCount: number;
}

const useFunktionsMenyItems = () => [];

const EkonomiskAnalysKoppladeVerifikationer: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const [refIdOpen, setRefIdOpen] = useState<string | null>(null);

  const columns: IColumnDef[] = [
    { attributeDef: 'VER_NR_2', header: true, caption: 'Vernr' },
    { attributeDef: 'Verifikation2.DATUM', caption: 'Bokföringsdatum' },
    { attributeDef: 'Verifikation2.TEXT', caption: 'Text' },
    { attributeDef: 'NOTERING', caption: 'Notering vid ändring' },
    { attributeDef: 'Verifikation2.VERKAT_KOD', caption: 'Skapad i rutin' },
    { attributeDef: 'Verifikation2.Signatur', caption: 'Registrerad av' },
    // TODO: visa nivå, ursprung på något sätt?
  ];
  const collection = findCollectionStatic('EKBokfverref');
  const urval = { pages: [] };

  const onReferensClick = useMemo(
    () => (id: TSelectedDetail | null) => {
      setRefIdOpen(selectedId(id));
    },
    []
  );

  if (collection) {
    return (
      <EDFullscreenPaper fullHeight>
        <ObjektVySida caption="" collectionName="" forceActive sidNr={1}>
          <AttributGrupp>
            <VisningsTypContext.Provider
              value={{
                rutinId: rutinInfos.rtnEkonomiskAnalys.rutinID,
                setVisningsTyp: () => {},
                visningsTyp: 'lista',
              }}
            >
              <EDSortableTable
                sortInfo={{
                  rows: props.referenser.map(ref => ({
                    VER_NR_2: ref.verNr,
                    BOKF_AR_2: ref.bokfar,
                    NOTERING: ref.notering,
                    _Associations: {
                      Verifikation2: {
                        DATUM: ref.bokfDatum,
                        TEXT: ref.text,
                        VERKAT_KOD: ref.verkat,
                        Signatur: ref.signature,
                      },
                    },
                    id: ref.id,
                    _version: 1,
                  })),
                  properties: [
                    { caption: '', order: 'desc', orderBy: 'verNr' },
                  ],
                }}
                getValue={(row, colName) => (row as unknown as Record<string, unknown>)[colName] as string | number | null}
                compareFunction={(a, b, order) =>
                  numberOrStringCompare(a, b, order)
                }
              >
                {({ createSortHandler, sortInfo }) => (
                  <BusinessDataSet
                    collection={collection}
                    columns={columns}
                    urval={urval}
                    setUrval={() => {}}
                    refetch={() => {}}
                    loading={false}
                    selectedId={null}
                    inlineDetail={null}
                    selectDetail={onReferensClick}
                    selectNewDetail={() => {}}
                    selected={[]}
                    toggleSelected={() => {}}
                    sortedData={sortInfo}
                    updateSortOrder={() => {}}
                    inCard
                    useFunktionsMenyItems={useFunktionsMenyItems}
                    doNotUseFunktionsMeny
                    settingsId="EkonomiskAnalysKoppladeVerifikationer"
                  />
                )}
              </EDSortableTable>
            </VisningsTypContext.Provider>
            <VerifikationDialog
              open={refIdOpen != null}
              verifikationId={refIdOpen ?? undefined}
              onClose={() => onReferensClick(null)}
              onExited={() => onReferensClick(null)}
              canViewFullVerifikationInfo={props.canViewVerifikationRader}
              backdropInvisible
              indentLevel={props.referenceCount + 1}
            />
          </AttributGrupp>
        </ObjektVySida>
      </EDFullscreenPaper>
    );
  } else {
    return null;
  }
};

export default EkonomiskAnalysKoppladeVerifikationer;
